import React from "react";
import PropTypes from "prop-types";

import {} from "reactbulma"; // musi zostac, zeby bulma sie zaczytala
import "../css/bulmaChanges.css";
import logo from "../img/oetker-logo.svg";

import FlashMessagesList from "./flash/FlashMessagesList";

const App = props => (
  <div className="main-container">
    <div className="header sticky-top-header">
      <div className="header-decoration" />
      <div className="container">
        <img
          alt="logo"
          className="logo container"
          width="108"
          height="74"
          src={logo}
        />
      </div>
    </div>

    <FlashMessagesList />
    <div className="flex-wrapper">
      <div className="inner-wrapper">{props.children}</div>
    </div>
    <footer className="footer sticky-footer">
      <div className="container">
        <div className="content">
          <p>© {new Date().getFullYear()} Dr. Oetker Polska</p>
        </div>
      </div>
    </footer>
  </div>
);
App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};
export default App;



// WEBPACK FOOTER //
// ./src/components/App.js